/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   export class PnicDetailsDialogLldpViewComponent {

      public bindings: any;
      public controller: any;
      public template: string;

      constructor() {
         this.bindings = {
            data: "<"
         };

         this.controller = PnicDetailsDialogLldpViewComponentController;

         this.template = `<vx-property-view class="network-ui-fixed-size-vx-property-view"
                                            data="$ctrl.propertyViewData"/>`;
      }
   }

   class PnicDetailsDialogLldpViewComponentController {

      static $inject = [
         "physicalAdapterDetailsViewService"
      ];

      data: any;

      propertyViewData: any;

      constructor(private physicalAdapterDetailsViewService: any) {}

      $onInit(): void {
         this.propertyViewData =
               this.physicalAdapterDetailsViewService.buildOnlyLldp(this.data);
      }
   }

   angular.module("com.vmware.vsphere.client.dvs")
         .component("pnicDetailsDialogLldpView",
               new PnicDetailsDialogLldpViewComponent ());
}
